import { Fee, getFeeThin } from "domain/fee";
import Offer from "domain/offer";
import { toContractTypeWithoutPricings } from "domain/offerType";
import { listAllowedFees } from "features/settings/general/fees/feeHelpers";
import * as _ from "lodash";

export function listAllowedFeesForOffer(fees: Fee[], offer: Offer) {
    if (offer == null) return [];

    let allowedFees = listAllowedFees(fees,
        offer.customerWillSell,
        offer.deliveryPeriod?.commodity ?? offer.commodity,
        toContractTypeWithoutPricings(offer.type),
        offer.type)
        .map(f => getFeeThin(f));

    //Adding the fees coming from parent contract while setting futures or basis
    if (offer.sourceContractId != null && offer.parentFees?.length > 0) {
        const missingParentFees = _.differenceBy(offer.parentFees, allowedFees, m => m.id);
        allowedFees = [...allowedFees, ...missingParentFees];
    }

    return allowedFees;
}